import styled from "styled-components";

export const BackButtonTextWrapper = styled.div`
  font-family: Ringside Regular-Bold;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #4e5ba6;
`;

export const BackButtonWrapper = styled.div`
  display: flex;
  padding: 24px 16px;
  gap: 19px;
  align-items: center;
`;
